import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NotificationService, Url } from 'src/app/common';
import { User, UserAuth } from 'src/app/common/user-auth';
import { ConfirmDialogService } from '../services/confirm-dialog.component';
import { LayoutService } from '../services/layout.service';
import { EmailNotification } from '../models/email-notification';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-email-notification',
  templateUrl: '../views/email-notification.component.html',
  styleUrls: ['../styles/style.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailNotificationComponent implements OnInit {
  userAuth: User = UserAuth.get();
  url = Url;
  @Output() public formClosed: EventEmitter<any> = new EventEmitter();
  emailNotification: EmailNotification = new EmailNotification();
  functions = [];
  employees = [];
  onSaving = false;
  historyDialog = { show: false, data: [] };
  searchVersionNrValue=null;

  constructor(
    public layoutService: LayoutService,
    public confirmDialogService: ConfirmDialogService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getAllFunctions();
  }

  getAllFunctions() {
    this.layoutService.getAllFunctions().subscribe((response) => {
      if (response.Status == 200) {
        this.functions = response.Functions.map(fnc => ({ id: fnc.id, role: fnc.role }));

        this.translateService.get("All").subscribe((text: string) => {
          this.functions.unshift({ id: -1, role: text });
        });
      }
    });
  }

  getEmailNotifications() {
    this.layoutService.getEmailNotifications().subscribe((response) => {
      this.historyDialog.data = response.Notifications;

      for (const item of this.historyDialog.data) {
        item.functions = JSON.parse(item.functions).map(fnc => (fnc.role)).join(',');
        item.employees = JSON.parse(item.employees).map(emp => (emp.fullName)).join(',');
      }
    });
  }

  openHistoryModal() {
    this.getEmailNotifications();
    this.historyDialog.show = true;
  }

  onSelectedFunctionsChange() {
    if (this.emailNotification.selectedFunctions.length === 0) {
      this.emailNotification.selectedEmployees = [];
      return;
    }

    let functionIds = [];
    if (this.emailNotification.selectedFunctions.find(fnc => fnc.id === -1))
      functionIds = this.functions.filter(fnc => fnc.id !== -1).map(fnc => (fnc.id));
    else
      functionIds = this.emailNotification.selectedFunctions.map(fnc => (fnc.id));

    this.layoutService.getEmployeesByFunctions(functionIds).subscribe((response) => {
      if (response.Status == 200) {
        this.employees = response.Employees.map(emp => ({ id: emp.id, fullName: emp.fullName, email: emp.email }));
        this.emailNotification.selectedEmployees = this.employees;
      }
    });

  }

  sendNotification() {
    this.onSaving = true;
    this.layoutService.sendEmailNotification(this.emailNotification).subscribe((response) => {

      if (response.Status == 200) {
        this.onSaving = false;
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    this.formClosed.next({});
  }
}
